import { render } from "./Synchronize.vue?vue&type=template&id=1fa69483&scoped=true"
import script from "../js/synchronize.js?vue&type=script&lang=js"
export * from "../js/synchronize.js?vue&type=script&lang=js"

import "./Synchronize.vue?vue&type=style&index=0&id=1fa69483&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa69483"]])

export default __exports__